export const defaultJourneyDomainState = {
    journeysByOrderId: {},
    journeysById: {},
    journeysByReference: {}
};
